











import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

import { EmbeddableArtifactEntryPointArgs } from '@/repositories';

import ko from 'knockout';
import { EmbeddableArtifact as EmbeddableArtifactKoC } from '@/apps/timeSeriesViewer/components/embeddableArtifactComponent';

import GrLoading from '@/components/GrLoading.vue';

@Component({
  components: { GrLoading }
})
export default class EmbeddableVueComponent extends Vue {
  @Prop()
  id!: string;

  @Getter('embeddableStore/embeddableEntryPointArgs') embeddableEntryPointArgs!: EmbeddableArtifactEntryPointArgs;

  @Action('embeddableStore/loadEmbeddableEntryPointArgs') loadEmbeddableEntryPointArgs!: (id: string) => Promise<void>;

  private loading = true;

  get isLoading(): boolean {
    return this.loading;
  }
  async created(): Promise<void> {
    await this.load();
  }

  @Watch('id')
  private async load() {
    this.loading = true;
    await this.loadEmbeddableEntryPointArgs(this.id);
    this.loading = false;
    const args = await new EmbeddableArtifactKoC.ArgsFactory().create(this.embeddableEntryPointArgs, this);
    ko.cleanNode(document); // for reloading in dev or when id changes on the fly
    ko.applyBindings(args);
  }
}
